module.exports = __webpack_public_path__ + "img/logo.adfa5c22.png";